import { notification } from 'antd'
import { onActionError, onFormError } from '../../../core/utils/hooks'

import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import {
  load,
  update,
  createEventNotAvailable,
  dismissEvent,

  rejectPrices,

  updatePaymentMethod,
  cancelPaymentMethod
} from '../../../api/vendor/user/show'

const key = 'vendor.user.show'

export const useFetch = () => {
  return useQuery({
    queryKey: [key],
    queryFn: () => load(),
    onError: onActionError
  })
}

export const usePutForm = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: update,
    onSuccess: () => {
      // Invalidate and refetch
      queryClient.invalidateQueries([key])

      notification.success({
        message: 'Updated',
        description: 'The template was updated'
      })
    },
    onError: onFormError
  })
}

export const useCreateEventNotAvailable = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: createEventNotAvailable,
    onSuccess: () => {
      // Invalidate and refetch
      queryClient.invalidateQueries([key])

      notification.success({
        message: 'Updated',
        description: 'The event was updated'
      })
    },
    onError: onFormError
  })
}

export const useDismissEvent = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: dismissEvent,
    onSuccess: (data, variables, context) => {
      // Invalidate and refetch
      queryClient.invalidateQueries([key])
    },
    onError: onActionError
  })
}

export const useRejectPrices = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: rejectPrices,
    onSuccess: (data, variables, context) => {
      // Invalidate and refetch
      queryClient.invalidateQueries([key])

      notification.success({
        message: 'Updated',
        description: 'The price review was canceled.'
      })
    },
    onError: onActionError
  })
}

export const useCancelPaymentMethod = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: cancelPaymentMethod,
    onSuccess: (data, variables, context) => {
      // Invalidate and refetch
      queryClient.invalidateQueries([key])

      notification.success({
        message: 'Updated',
        description: 'The payment method review was canceled.'
      })
    },
    onError: onActionError
  })
}

export const usePutPaymentMethod = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: updatePaymentMethod,
    onSuccess: () => {
      // Invalidate and refetch
      queryClient.invalidateQueries([key])

      notification.success({
        message: 'Updated',
        description: 'The payment method was updated'
      })
    },
    onError: onFormError
  })
}
/*
export const useRemovePaymentMethod = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: deletePaymentMethod,
    onSuccess: () => {
      // Invalidate and refetch
      queryClient.invalidateQueries([key])

      notification.success({
        message: 'Deleted',
        description: 'The payment method was deleted'
      })
    },
    onError: onDeleteError
  })
} */
